import { pipe, symmetricDifference, isEmpty } from 'ramda';

export function isSameValues(array1, array2) {
  return pipe(symmetricDifference(array2), isEmpty)(array1);
}
